import { FieldConfig } from '../../models/form-field.model';

export type FormFileUploadTemplate = 'button' | 'text';
export interface FormFileUploadOptions {
  type: FormFileUploadTemplate;
  color?: 'primary' | 'accent' | 'warn';
  icon?: string;
}

export class FormFileUploadField<T = any> extends FieldConfig {

  maxFileSizeMB?: number;
  multiple?: boolean;
  maxFiles?: number;
  template: FormFileUploadOptions;
  buttonStyle?: any;
  labelStyle?: {
    container?: any;
    icon?: any;
    span?: any;
  };

  filesStyle?: {
    container?: any;
    fileItem?: any
    label?: any;
    clearIcon?: any;
    previewIcon?: any;
  };

  constructor(o: FormFileUploadField) {
    super(o);
    this.type = 'fileUpload';

    this.maxFileSizeMB = this.maxFileSizeMB || 2;

    if (!this.labelStyle) {
      this.labelStyle = {
        container: null,
        icon: null,
        span: null
      };
    }

    if (!this.filesStyle) {
      this.filesStyle = {
        container: null,
        fileItem: null,
        label: null,
        clearIcon: null,
        previewIcon: null
      };
    }
  }

  addFile?() {
    console.error('Add file não foi implementado');
  }


}
